import { render } from "./ProfileAttachments.vue?vue&type=template&id=eeb97be0&scoped=true"
import script from "./ProfileAttachments.vue?vue&type=script&lang=js"
export * from "./ProfileAttachments.vue?vue&type=script&lang=js"

import "./ProfileAttachments.vue?vue&type=style&index=0&id=eeb97be0&scoped=true&lang=css"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb97be0"]])

export default __exports__